<template>
  <div class="mt-20">
    <el-tabs v-model="activeName" type="border-card" @tab-click="tabClick">
      <template v-for="(item, index) in resources">
        <el-tab-pane :label="item.name" :name="item.key">
          <p class="font-12">
            提示：{{ userName }} 将可以查看下面被勾选范围的客户和订单等数据。
          </p>
          <p v-if="!isadealer">
            <el-radio v-model="all" :label="0">区域人员</el-radio>
            <el-radio v-model="all" :label="1">全区域</el-radio>
          </p>
          <rselect
            :options="item.items"
            :value="item.selected"
            :rkey="item.key"
            :disabled="all == 1"
            :userID="userID"
            :category="2"
            @saveCallback="saveCallback($event, index)"
          ></rselect>
        </el-tab-pane>
      </template>
    </el-tabs>
  </div>
</template>


<script>
import { resourceList, userResourceList } from '@/service/getData'
import { isMobile } from '@/util/index'
import Rselect from '@/views/resource/selector'
import store from '@/store/store'

export default {
  props: {
    userID: 0,
    userName: '',
    areaID: 0,
  },
  components: {
    Rselect,
  },
  data() {
    return {
      all: 0,
      activeName: '',
      isMobile,
      resources: [],
      user: {},
      // keyName: { user: '销售', area: '区域' },
      isadealer: store.getters.userInfo.dealer_id > 0,
    }
  },
  watch: {
    areaID() {
      this.getResources()
    },
  },
  created() {
    // this.getResources()
  },
  methods: {
    tabClick(e) {
      this.all = this.resources[e.index].all ? 1 : 0
    },
    async getResources() {
      let res = await resourceList()
      let filterPlatform = this.isadealer ? 1 : 2
      if (res.code == 0) {
        this.resources = res.data.list
          .filter((it) => it.platform != filterPlatform)
          .map((item) => {
            // item.keyName = this.keyName[item.key]
            item.items.map((it) => {
              it.id = parseInt(it.value)
            })
            item.selected = []
            return item
          })

        if (!this.isadealer) {
          this.resources = this.resources
            .filter((item) => item.key == 'area')[0]
            .items.map((item) => {
              item.items = this.resources[0].items.filter(
                (it) => it.area_id == item.id
              )
              item.selected = []
              item.key = item.id.toString()
              return item
            })
        }
        if (this.resources.length > 0) {
          this.activeName = this.resources[0].key
        }
        this.getUserResources(true)
      }
    },
    async getUserResources(init = false) {
      if (!parseInt(this.userID) > 0) {
        this.resources.map((item) => {
          item.selected = []
        })
        return
      }
      let res = await userResourceList({
        user_id: this.userID,
        key: '',
      })
      if (res.code == 0) {
        this.resources.map((item) => {
          let selected = []
          if (this.isadealer) {
            selected = res.data.list.filter((i) => i.key == item.key)
          } else {
            item.all = false
            let filterItems = res.data.list.filter(
              (i) => i.area_id.toString() == item.key
            )

            if (filterItems[0]) {
              item.all = filterItems[0].all_area == 1
            }

            selected = filterItems.filter((i) =>
              item.items.some((it) => eval(i.value).indexOf(it.id) != -1)
            )
          }
          if (selected.length > 0) {
            item.selected = eval(selected[0].value)
          } else {
            item.selected = []
          }
        })
      }

      if (this.resources.length > 0 && !this.isadealer) {
        if (init) {
          this.activeName = '2'
          setTimeout(() => {
            this.activeName = '1'
            this.tabClick({
              index: this.activeName ? parseInt(this.activeName) - 1 : 0,
            })
          }, 300)
        }
      }
    },
    saveCallback(e, index) {
      if (this.isadealer) {
        this.resources[index].selected = e
      } else {
        this.getUserResources()
      }
    },
  },
}
</script>

<style>
.el-tabs--border-card,
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background: #ffffff;
}
</style>

<style scoped>
.long {
  width: 100%;
}
/deep/.el-checkbox {
  width: 120px;
}
</style>